import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { UserBaseModel } from '@core/api';
import { FormBuilder } from '@angular/forms';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'user-information',
  templateUrl: './user-information.component.html',
  styleUrls: ['./user-information.component.scss']
})
export class UserInformationComponent {
  @Input() user: UserBaseModel;

  loading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public userService: UserService
  ) {}
}
